module.exports = __webpack_public_path__ + "static/img/description-station-keeping-parametric.5b9a8f3.png";